export default "__VITE_ASSET__aVxiBvJg__"